module.exports = __webpack_public_path__ + "902bea6205f30e0627eafdbc89ae33e1.png";